import { render, staticRenderFns } from "./ExhibitionList.vue?vue&type=template&id=52b9cb10&scoped=true"
import script from "./ExhibitionList.vue?vue&type=script&lang=js"
export * from "./ExhibitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9cb10",
  null
  
)

export default component.exports